import React from 'react'
import RankingItem from '../RankingItem'

const Ranking = ({ ranking }) => {
  const three = ranking.slice(0, 6)
  const four = ranking.slice(-4, ranking.length)

  return (
    <div className="container relative mx-auto">
      <div className=" sm:grid sm:grid-cols-3">
        {three.map((item, index) => {
          return (
            <RankingItem
              key={index}
              complex={true}
              data={item}
              position={index + 1}
            />
          )
        })}
      </div>
      <div className=" sm:grid sm:grid-cols-4">
        {four.map((item, index) => {
          return (
            <RankingItem
              key={index}
              complex={true}
              data={item}
              position={index + 1 + three.length}
              className="smaller"
            />
          )
        })}
      </div>
    </div>
  )
}

export default Ranking
